import { NodejsSDKModule } from './nodejs-sdk.class'

export const register = ({ name, version, description, rawApis = [], sdkApis = [], ...options }) => {
  const moduleInstance = new NodejsSDKModule({ name, version, description, options }).registerModule()

  if (Array.isArray(rawApis)) {
    rawApis.forEach(({ name, action }) => {
      if (!name || !action) {
        return
      }
      moduleInstance.registerRawApi(name, action)
    })
  }

  if (Array.isArray(sdkApis)) {
    sdkApis.forEach(({ name, action }) => {
      if (!name || !action) {
        return
      }
      moduleInstance.registerSDKApi(name, action)
    })
  }

  return moduleInstance
}

export default {
  register
}
